import styled from "styled-components";

export const TitleText = styled.h2`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  align-items: center;
  line-height: 1.5em;
  color: ${(props) => props.color || "#214160"};
`;

export const LabelText = styled.label<{ color?: string }>`
  color: ${(props) => props.color || "rgba(33, 65, 96, 0.4)"};
  font-weight: normal;
  font-size: 0.9em;
`;
export const BorderedLabelText = styled.label`
  color: #01A8CE;
  font-weight: normal;
  font-size: 0.9em;
  padding: 0.4em 0.7em;
  border: 1.5px solid #ebeeff;
  border-radius: 0.5em;
`;
